import { render, staticRenderFns } from "./ProductFormMobile.vue?vue&type=template&id=377bd116&scoped=true&"
import script from "./ProductFormMobile.vue?vue&type=script&lang=js&"
export * from "./ProductFormMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProductFormMobile.vue?vue&type=style&index=0&id=377bd116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377bd116",
  null
  
)

export default component.exports